<template>
  <van-popup v-model="popupShow" round position="bottom">
    <div class="popup-box">
      <div class="plat-title">
        <h1>请选择游戏支付的平台</h1>
      </div>
      <div class="pay-list-card">
        <div
          class="pay-card-item"
          v-for="item in payList"
          :key="item.id"
          @click="payway = item.id"
        >
          <div class="pay-palt">
            <img :src="item.payIcon" alt="" />
            <span>{{ item.payName }}</span>
          </div>
          <div class="chose-btn">
            <span v-if="item.id == 'balance'">¥{{ item.amount }}</span>
            <img
              v-if="payway != item.id"
              src="@/assets/images/ic_status_grey_two.png"
              alt=""
              class="chose-icon"
            />
            <img
              v-else
              src="@/assets/images/ic_status_ok_two.png"
              alt=""
              class="chose-icon"
            />
          </div>
        </div>
        <van-button
          color="#FF7A3E"
          :text="loading ? (payway == 'alipay' ? '正在跳转' : '正在支付') : '立即支付'"
          round
          type="primary"
          size="large"
          :disabled="loading"
          style="margin-top: 10px"
          @click="handlepay"
        ></van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    btnType: {
      type: String,
      default: "",
    },
    payInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(["uuid", "userInfo"]),
    popupShow: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      payList: [
        {
          payIcon: require("@/assets/images/ic_ali_pay.png"),
          payName: "支付宝支付",
          id: "alipay",
        },
        // {
        //   payIcon: require("@/assets/images/ic_wechat_pay_two.png"),
        //   payName: "微信支付",
        //   id: "wechatpay",
        // },
        {
          payIcon: require("@/assets/images/ic_balance_pay_two.png"),
          payName: "余额支付",
          id: "balance",
          amount: "0.00",
        },
      ],
      payway: "alipay",
      loading: false,
    };
  },
  mounted() {
    this.payList[1].amount = this.userInfo.account || "0.00";
  },
  methods: {
    handlepay() {
      if (this.loading) return;
      this.loading = true;

      if (this.payway == "alipay") {
        this.aliPaySubmit();
      }
      if (this.payway == "balance") {
        this.balanceSubmit();
      }
    },
    /**
     * 支付宝支付
     */
    async aliPaySubmit() {
      try {
        const { data } = await requestMethods(
          this.payInfo.apiUrl,
          "post",
          {
            ...this.payInfo,
            payWay: "alipay_h5"
          }
        );
        sessionStorage.setItem('RECHARGE_AMOUNT', JSON.stringify(this.payInfo.amount))
        const { body } = data.orderInfo;
        this.submitForm(body);
      } catch (err) {
        this.$toast(err.message);
      }
    },

    /**
     * 余额支付
     */
    async balanceSubmit() {
      try {
        await requestMethods(
          this.payInfo.apiUrl,
          "post",
          {
            ...this.payInfo,
            payWay: "balance"
          }
        );
        if(this.payInfo.apiUrl == '/modules/RechargeAction/doGameRecharge.htm') {
          this.$router.push({
            path: "/payResult",
            query: {amount: this.payInfo.amount, payway: 'balance'}
          });
        } else {
          let msg = ''
          if(this.payInfo.apiUrl == '/modules/goods/userMonthCard/buyMonthCard.htm') {
            msg = '购买成功'
          } else if(this.payInfo.apiUrl == '/modules/accounttx/accountBuy/applyBuyGameAccount.htm') {
            msg = '购买成功'
          } else {
            msg = '充值成功'
          }
          this.$toast(msg);
          this.$emit('balancePayEvent')
        }
        
      } catch (err) {
        this.$toast(err.message);
        this.loading = false
      }
    },

    submitForm(formHtml) {
      const div = document.createElement("div");
      div.innerHTML = formHtml; // 将HTML表单插入到div中
      document.body.appendChild(div); // 将div添加到body中
      const form = div.querySelector("form"); // 查找插入的表单
      if (form) {
        form.submit(); // 自动提交表单
      } else {
        console.error("未找到表单");
        this.loading = false; // 重置按钮状态
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.popup-box {
  padding: 30px;
  margin-bottom: 30px;
  .plat-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;

    h1 {
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 36px;
      color: #535353;
    }
  }
  .pay-list-card {
    .pay-card-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 32px 73px 32px 63px;

      .pay-palt {
        display: flex;
        align-items: center;
        img {
          width: 50px;
          height: 50px;
          margin-right: 40px;
        }
        span {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 36px;
          color: #434343;
        }
      }

      .chose-btn {
        display: flex;
        align-items: center;

        span {
          margin-right: 26px;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 36px;
          color: #ff7a3e;
        }
        .chose-icon {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/RechagePayWayPopup.vue